import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=441e6b8f&"
import script from "./newsList.vue?vue&type=script&lang=js&"
export * from "./newsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports